import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
@Component({
  selector: 'app-menus',
  standalone: true,
  imports: [MatMenuModule, MatButtonModule,MatButtonModule, MatMenuModule,RouterLink],
  templateUrl: './menus.component.html',
  styleUrl: './menus.component.scss'
})
export class MenusComponent implements OnInit {

  @Output() selectedmenu = new EventEmitter<string>();
  router = inject(Router);
  private localStorage = inject(AesEncDecService);
  userDisplayName: string | undefined;

   ngOnInit(): void {
    const loginDetails = JSON.parse(this.localStorage.getData('loginDetails') || '{}');
    this.userDisplayName = loginDetails[0]?.userDisplayName;
  }
  loadRegistrationPage(selectedmenu: string) {
    if(selectedmenu==="create-registration")
      this.router.navigateByUrl('create-registration');
      
    
    this.selectedmenu.emit(selectedmenu);
    console.log('Selected Menu:', selectedmenu);
  }
  loadPaymentPage(selectedmenu: string) {
    if(selectedmenu==="client-payment")
      this.router.navigateByUrl('client-payment');
      
    
    this.selectedmenu.emit(selectedmenu);
    console.log('Selected Menu:', selectedmenu);
  }
  loadCatalogueView(selectedmenu: string) {
    if(selectedmenu==="view-catalogue")
      this.router.navigateByUrl('catalogue-view');
      
    
    this.selectedmenu.emit(selectedmenu);
    console.log('Selected Menu:', selectedmenu);
  }
}
